module.exports = __webpack_public_path__ + "img/CO2ppm.3e54a3e4.png";